import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const trialExtensionModalOpenAtom = atom<boolean>(false);
export const trialExtensionInviteModalOpenAtom = atom<boolean>(false);
export const reopenTrialExtensionModalAfterActionAtom = atom<boolean>(false);

/** Persisted: when true, "Earn days" nav item is permanently hidden after user closed the completed (14-day extension earned) trial extension modal. */
export const earnDaysNavPermanentlyDismissedAtom = atomWithStorage<boolean>(
  'heidi-earn-days-nav-dismissed',
  false
);

/** Persisted: when true, user has opened/seen the trial extension modal at least once; used to hide the 0% prompt indicator on the sidebar nav item. */
export const hasSeenTrialExtensionModalAtom = atomWithStorage<boolean>(
  'heidi-earn-days-modal-seen',
  false
);

/** Persisted: when true, the one-time "all gamified trial tasks complete" celebration tooltip has been shown and should never reappear. */
export const hasSeenTrialCompletionTooltipAtom = atomWithStorage<boolean>(
  'heidi-trial-completion-tooltip-seen',
  false
);
